module.exports = __webpack_public_path__ + "static/img/layout1.8c97f3f4.png";